import { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import "./HowTronWorks.scss";
import GetStartedModal from "../../GetStartedModal";

const HowTronWorks = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box className="how-tron-works">
      <Box className="how-tron-works__header">
        <Typography
          variant="h4"
          className="how-tron-works__title"
          style={{ fontSize: isMobile ? "2.0rem" : "" }}
        >
          How Tron Saves You Money on OPD Healthcare
        </Typography>
        <Typography variant="subtitle1" className="how-tron-works__subtitle">
          3 simple steps to get the best OPD healthcare plan.
        </Typography>
      </Box>

      <Box className="how-tron-works__card-container">
        <Box className="how-tron-works__card">
          <Typography variant="h5" className="emoji">
            1️⃣
          </Typography>
          <Typography variant="h6" className="card-title">
            Buy Your Plan
          </Typography>
          <Typography className="card-text">
            Choose an annual Tron OPD plan to unlock up to 70% savings on all
            OPD & lab healthcare services.
          </Typography>
        </Box>

        <Box className="how-tron-works__card">
          <Typography variant="h5" className="emoji">
            2️⃣
          </Typography>
          <Typography variant="h6" className="card-title">
            Book Through Tron
          </Typography>
          <Box className="card-text">
            {/* <Typography sx={{ fontWeight: 600 }}>
              Mandatory: Use the Tron website to:
            </Typography> */}
            <li> Book discounted doctor consultations.</li>
            <li> Schedule lab tests at home at 50% off.</li>
            <li> Purchase preventive health packages at unbeatable prices.</li>
          </Box>
        </Box>

        <Box className="how-tron-works__card">
          <Typography variant="h5" className="emoji">
            3️⃣
          </Typography>
          <Typography variant="h6" className="card-title">
            Show & Save
          </Typography>
          <Typography className="card-text">
            Present your Tron-booking confirmation (QR code/ID) to avail
            discounts at your nearest Tron partner clinic.
          </Typography>
        </Box>
      </Box>

      <Box className="how-tron-works__actions">
        <Button
          variant="outlined"
          color="inherit"
          className="how-tron-works__button"
          onClick={() => (window.location.href = "tel:1234567890")}
        >
          📞 Need help booking?
        </Button>
        <Button
          onClick={handleOpen}
          variant="contained"
          color="secondary"
          className="how-tron-works__button"
        >
          Join Tron Now
        </Button>
        <GetStartedModal open={open} handleClose={handleClose} />
      </Box>
    </Box>

    // <Box className="how-tron-works">
    //   <Typography variant="h4" className="how-tron-works__title">
    //     How Tron Saves You Money on OPD Healthcare
    //   </Typography>
    //   <Typography variant="subtitle1" className="how-tron-works__subtitle">
    //     3 simple steps to get the best OPD healthcare plan.
    //   </Typography>

    //   <Box className="how-tron-works__steps">
    //     <Box className="how-tron-works__step">
    //       <Typography variant="h6">1️⃣ Buy Your Plan</Typography>
    //       <Typography>
    //         Choose an annual Tron OPD plan to unlock up to 70% savings on all OPD & lab healthcare services.
    //       </Typography>
    //     </Box>

    //     <Box className="how-tron-works__step">
    //       <Typography variant="h6">2️⃣ Book Through Tron</Typography>
    //       <Box className="how-tron-works__list">
    //         <Typography>Mandatory: Use the Tron website to:</Typography>
    //         <Typography> Book discounted doctor consultations</Typography>
    //         <Typography> Schedule lab tests at home at 50% off</Typography>
    //         <Typography> Purchase preventive health packages at unbeatable prices</Typography>
    //       </Box>
    //     </Box>

    //     <Box className="how-tron-works__step">
    //       <Typography variant="h6">3️⃣ Show & Save</Typography>
    //       <Typography>
    //         Present your Tron-booking confirmation (QR code/ID) to avail discounts at your nearest Tron partner clinic.
    //       </Typography>
    //     </Box>
    //   </Box>

    //   <Box className="how-tron-works__actions">
    //     <Button
    //       variant="outlined"
    //       color="inherit"
    //       className="how-tron-works__button"
    //       onClick={() => window.location.href = "tel:1234567890"}
    //     >
    //       📞 Need help booking?
    //     </Button>

    //     <Button
    //       variant="contained"
    //       color="secondary"
    //       className="how-tron-works__button"
    //       onClick={() => window.location.href = "/plans"}
    //     >
    //     Join Tron Now
    //     </Button>
    //   </Box>
    // </Box>
  );
};

export default HowTronWorks;
